<script setup lang="ts">
import type { RelatedDocumentData } from '~/utils/crystallize/component-schemas'

const { data } = defineProps<{ data: RelatedDocumentData }>()

const { data: article } = useArticle(data.path)
</script>

<template>
  <ClientOnly>
    <ContentGrid is="section" v-if="article">
      <div class="hidden lg:flex items-center gap-2xl col-span-full py-3xl px-5xl rounded-4xl bg-blurple-50">
        <div class="flex flex-col gap-m basis-1/3 lg:basis-1/2">
          <h2 v-if="article.components?.title" class="title-l" v-text="article.components?.title" />
          <CrystallizeRichText v-for="(block, i) in article?.components?.leadParagraph" :key="i" :block="block" class="text-lg" />
          <Button
            :to="article.path"
            color="moss"
            size="medium"
            variant="primary"
          >
            Les artikkel
          </Button>
        </div>

        <CrystallizeClippedImage
          v-if="article.components?.headerImage"
          :image="article.components?.headerImage"
          path="octagon-left"
          class="basis-1/2"
          img-class="rounded-r-3xl"
        />
      </div>
      <div class="lg:hidden col-span-full flex flex-col gap-s px-m py-l md:py-3xl md:px-5xl md:gap-2xl rounded-4xl bg-blurple-50">
        <h2 v-if="article.components?.title" class="title-m" v-text="article.components?.title" />

        <CrystallizeClippedImage
          v-if="article.components?.headerImage"
          :image="article.components?.headerImage"
          path="octagon-right"
          img-class="rounded-l-3xl"
        />

        <CrystallizeRichText v-for="(block, i) in article?.components?.leadParagraph" :key="i" :block="block" />
        <Button
          :to="article.path"
          color="moss"
          size="small"
          variant="primary"
        >
          Les artikkel
        </Button>
      </div>
    </ContentGrid>
  </ClientOnly>
</template>
